import { TextArea } from '@pms-digital/design-system';
import { useId } from 'react';

/**
 * The optional comment that steers a whole run of digests (issue #20): the
 * bulk « Préparer les digests maintenant » and the « Redérouler » of stale
 * digests. Always on screen, directly above the button that sends it; the
 * button leaves with whatever the field holds, empty or not.
 *
 * Per-card comments have their own, single-line field inside
 * `DigestVersionCard`.
 */

export interface DigestCommentFieldProps {
  /** What the comment orients — one sentence, shown under the label. */
  help: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  /** Marks the field as refused (comment over the ceiling). */
  invalid?: boolean;
}

export function DigestCommentField({
  help,
  value,
  onChange,
  disabled = false,
  invalid = false,
}: DigestCommentFieldProps) {
  const id = useId();

  return (
    <TextArea
      label="Commentaire (facultatif)"
      help={help}
      id={id}
      aria-invalid={invalid}
      status={invalid ? 'error' : 'default'}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
    />
  );
}
